import { render, staticRenderFns } from "./ListPagoComponent.vue?vue&type=template&id=e6e84270&scoped=true"
import script from "./ListPagoComponent.vue?vue&type=script&lang=js"
export * from "./ListPagoComponent.vue?vue&type=script&lang=js"
import style0 from "./ListPagoComponent.vue?vue&type=style&index=0&id=e6e84270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e84270",
  null
  
)

export default component.exports